import axios from 'axios';
import { useDispatch } from 'react-redux';
import { themeRegister } from 'src/actions/themeActions';

const URL_STATIC_THEME = 'https://estaticopre.cabal.coop.py/public/dimo/theme1/images/';
const BASE_URL = 'https://estaticopre.cabal.coop.py/public/dimo';

/**
 * Función asíncrona para obtener y procesar datos desde una URL.
 */
async function fetchData(url) {
  let data;
  let error;
  let loading = true;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const dataText = await response.text();
    const fixText = dataText.replace(/'/g, '"').replace(/(\w+)\s*:/g, '"$1":').replace(/"https"/g, 'https').replace(/,\s*}/g, '}');
    const jsonData = JSON.parse(fixText);
    data = jsonData;
  } catch (err) {
    error = err.message;
  } finally {
    loading = false;
  }

  return { data, loading, error };
}


async function loadThemeConfig(dispatch, themeConfigRemote) {
  await dispatch(themeRegister(themeConfigRemote));
  localStorage.setItem('themeConfig', JSON.stringify(themeConfigRemote));
}


/**
 * Función asíncrona para obtener la configuración de una URL específica.
 */
async function fetchConfig(url) {
  try {
    const urlActual = window.location.href;
    let url= urlActual.split('/')[2];
    
    if (url.includes('localhost') || url.includes('10.5.2.149')) {
      url = 'dpagotest.cabal.coop.py'; // Para desarrollo local, cambiar por el codparticipante que quieras probar
    }

    const config = await fetchData(`${BASE_URL}/${url}/config.js`);

    if (config.error) {
      console.error(`Error al obtener config de ${url}:`, config.error);
      return { error: config.error };
    }

    let paleta = { data: {} };
    if (config.data?.paleta) {
      try {
        paleta = await fetchData(config.data.paleta);
        if (paleta.error) {
          console.warn(`Error al obtener paleta de ${url}:`, paleta.error);
        }
      } catch (error) {
        console.warn(`Error al obtener paleta de ${url}:`, error);
      }
    }

    if (config.data?.requireAuth !== undefined) {
      localStorage.setItem("requireAuth", JSON.stringify(config.data.requireAuth));
    }

    return { ...config.data, ...paleta.data };
    
//          const config = {
//   "code": null,
//     "afinidad": "115009",
//   "tarjetaEmisor":[],
//   "paleta":"https://estaticopre.cabal.coop.py/public/dimo/theme/115009/palette/palette.js",
//   "loginView": {
//     "logoUrl": "https://estaticopre.cabal.coop.py/public/dimo/115009/images/logoUrl.png",
//     "backgroundWebImage":"https://estaticopre.cabal.coop.py/public/dimo/theme/115009/images/backgroundWebImage.jpg",
//     "backgroundMobileImage":"https://estaticopre.cabal.coop.py/public/dimo/theme/115009/images/backgroundMobileImage.jpg"
//   },
//   "headerIcon":"https://estaticopre.cabal.coop.py/public/dimo/115009/images/headerIcon.png",
//   "splashIcon":"https://estaticopre.cabal.coop.py/public/dimo/115009/images/splashIcon.png",
//   "buttonIcon":"https://estaticopre.cabal.coop.py/public/dimo/115009/images/buttonIcon.png",
// 	"institucional":"https://dpago.com/",
// 	"nombre":"Dpago",
//   "requireAuth": false,
// 	"backgroundWebInicio": null,
// 	"backgroundMobileInicio": null,
// 	"requiereFullTheme": false,
// 	"requiereDarkLogin": false,
// 	"promotor": "PAGO",
//   "codeListarAlias":"1600",
//   "cvvRequire":true,
//   "solitudPlasticoRequire":true,
//   "activacionPlasticoRequire":true,
//   "solicitudReimpresionRequire":true,
//   "recuperarPinRequire":true,
//    "requiereFactura": true,
//    "requiereExcedentes": true,
//    "requierePrestamoColegioSeparado":false,
//    "requiereCajaAhorroAuto": true,
//    "requierePrestamoTipoCredito": false,
//     "requierePagoTarjetaExterno": false,
//   "logoWidthMax": "300px",
//   "logoWidthMin": "250px",
// }

//   const paleta = {
//     "backgroundColor": "#EEEEEE",
//     "primary": "#1591CC",
//     "secondary": "#1591CC",
//     "tertiary": "#000000",
//     "textPrimary": "#152C3B",
//     "textSecondary": "#707070",
//     "textTertiary": "#727C8E",
//     "cardBackground":"#dcdcdc",
//     "spinner": "#1591CC",
//     "navbarLeft": {
//         "backgroundColor": "#1591CC",
//         "text": "#FFFFFF",
//         "icon": "#FFFFFF",
//     },
//     "navbarButtom": {
//         "backgroundColor": "#FFFFFF",
//         "text": "#000000",
//         "icon": "#000000",
//     },
//     "codPromotor":{
//         "title": "#FFFFFF",
//         "code": "#FFFFFF",
//     },
//     "buttonSection": {
//         "backgroundColor": "#FFFFFF",
//         "text": "#FFFFFF",
//         "icon": "#1591CC",
//     },
//     "buttonStep": {
//         "backgroundColor": "#1591CC",
//         "text": "#FFFFFF",
//         "icon": "#FFFFFF",
//     },
//     "buttonExtra": {
//         "backgroundColor": "#FFFFFF",
//         "text": "#1591CC",
//         "icon": "#1591CC",
//     },
// }
// return {
//     ...config,
//     ...paleta
//   };

  } catch (error) {
    console.error(`Error en fetchConfig para ${url}:`, error);
    return { error };
  }
}


/**
 * Busca la configuracion basada en la URL y la almacena en localStorage.
 */
export async function handleGetStorage() {
  const urlActual = window.location.href;
  const url = urlActual.split('/')[2];

  const config = await fetchConfig(url);
  if (config.error) {
    return config;
  }

  localStorage.setItem('themeConfig', JSON.stringify(config));

  return config;
}